import React, { PureComponent } from 'react'
import './styles.sass'


class ToolTip extends PureComponent {

  showTip(evt) {
    const target = evt.currentTarget;
    target.querySelector('.tooltip').classList.add('active')
  }

  hideTip(evt) {
    const target = evt.currentTarget;
    target.querySelector('.tooltip').classList.remove('active')
  }

  render() {
    const { text, position } = this.props;
    const arrowPos = position || 'right';

    return (
      <span onMouseEnter={this.showTip} onMouseLeave={this.hideTip} className="abbr tooltip-wrapper">[?]
        <span className={`tooltip ${arrowPos}`}>{text}
          <span className="arrow"/>
        </span>
      </span>
    )
  }

}

export default ToolTip;


// WEBPACK FOOTER //
// ./assets/es6/common/components/Tooltip/index.es6